import React, { useState } from 'react';
import { AutoComplete, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './TextSearch.styles';

type TextSearchProps = {
  dataSource: any[];
  setValue: (arg: any, arg2?: any) => void;
  placeholder?: string;
  defaultOpen?: boolean;
  defaultValue?: string;
  style?: any;
  testid?: string;
  allowClear?: boolean;
  loading?: boolean;
};

const TextSearch: React.FC<TextSearchProps> = ({
  dataSource,
  setValue,
  placeholder,
  defaultOpen,
  defaultValue,
  style,
  testid,
  allowClear,
  loading,
}) => {
  const [inputVal, setInputVal] = useState(null);

  const onSelect = (value: any) => {
    if (value)
      setValue(
        value,
        dataSource.find((item) => item.value === value)
      );
  };

  const onBlur = () => {
    if (inputVal)
      setValue(
        inputVal,
        dataSource.find((item) => item.value === inputVal)
      );
  };

  const onChange = (value: any) => {
    if (value) {
      setInputVal(value);
      setValue(
        value,
        dataSource.find((item) => item.value === value)
      );
    } else if (allowClear) {
      setInputVal(null);
      setValue('', null);
    }
  };

  return (
    <>
      <div
        data-testid={`TextSearch-${testid}`}
        className="text-search"
        style={{ position: 'relative', ...style }}
      >
        <AutoComplete
          className="text-input"
          popupClassName="auto-complete-popup"
          defaultValue={defaultValue || ''}
          placeholder={placeholder || 'Type here...'}
          dataSource={dataSource}
          onSelect={onSelect}
          onBlur={onBlur}
          onChange={onChange}
          defaultOpen={defaultOpen || false}
          allowClear={allowClear}
          notFoundContent={loading ? 'Loading...' : undefined}
          // @ts-ignore
          filterOption={(inputValue, option) => {
            if (typeof option.props.children === 'string') {
              return (
                option.props.children
                  .toUpperCase()
                  .indexOf(inputValue.toUpperCase()) !== -1
              );
            }
          }}
        />
        {loading && (
          <div
            style={{
              position: 'absolute',
              right: allowClear ? 32 : 12,
              top: 0,
              bottom: 0,
              display: 'flex',
              alignItems: 'center',
              pointerEvents: 'none',
            }}
          >
            <Spin
              size="small"
              indicator={<LoadingOutlined spin style={{ color: '#0077be' }} />}
            />
          </div>
        )}
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default TextSearch;
